<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <!-- Contenet page started-->
  <div class="row">
    <div class="col-md-12">
       <!-- breadcrumb -->
      <div class="page-breadcrumb">
        <div>
          <ul class="page-breadcrumb__trail">
            <li><a>Subscriptions</a></li>
          </ul>
        </div>
        <div class="page-breadcrumb__icons">
          <a routerLink="/home/marketconnect"><img src="../../../../assets/images/New_Icons/home-transprent-icon.svg" title="Home"></a>
        </div>
      </div>
      <!-- breadcrumb End -->
    </div>
  </div>
  <!--market connect details table-->
  <div class="subscriptions-block-container">
    <div *ngIf="responseLoader">
      <div class="adjust">
        <div class="reports-loader"></div>
      </div>
    </div>
    <div *ngIf="!responseLoader" class="data-container">
      <div *ngIf="subscribersList && subscribersList.length > 0">
        <div class="toolbar" style="background: none;">
          <div class="toolbar__search" style="visibility: hidden;">
            <img src="../../../../../assets/images/New_Icons/search-icon.svg" alt="Search Icon" />
            <input type="text" (keyup)="applySearch()" [(ngModel)]="search" name="search" autocomplete="off" placeholder="Search by stage name and code " />
          </div>
          <div class="toolbar__spacer" style="visibility: hidden;"></div>
          <div class="toolbar__add-button" (click)="openForm()">
            <button type="button">
                            <span class="toolbar__add-icon">
                  <img src="../../../../../../assets/images/New_Icons/plus-icon.svg" alt="Add Icon" />
                </span>
              <span class="toolbar__add-text">Add New</span>
            </button>
          </div>
        </div>
        <div class="row card-container marketcard-container" id="marketCardContainer" style="margin-top: 2%; margin-bottom: 2%;position: relative;">
          <div class="row list">
            <div class="col-xs-4">
              <p class="tableheading">Subscriptions - Report</p>
            </div>
            <div class="col-xs-4">
            </div>
            <div class="col-xs-4" style="padding:0">
            </div>
          </div>
          <div class="row list">
            <div class="col-xs-12" style="border-bottom: 1px solid #ccc;">
              <div class="row">
                <ul class="nav nav-tabs batch batchtransactiontabs">
                  <li (click)="switchPolicyTypeData('businessContacts')" [ngClass]="{ 'active' : isBusinessContactsTabActive}"><a data-toggle="tab" href="#businessContacts">Business Contacts</a></li>
                  <li (click)="switchPolicyTypeData('blueEyePlan')" [ngClass]="{ 'active' : isBluEyeSubscribersTabActive }"><a data-toggle="tab" href="#isBluEyeSubscribers">BluEye</a></li>
                </ul>
              </div>
            </div>
          </div>
          <div *ngIf="(isBusinessContactsTabActive && businessContacts && businessContacts.length > 0)
                || (isBluEyeSubscribersTabActive && bluEyeSubscribers && bluEyeSubscribers.length > 0)">
            <div class="reports-toolbar" style="margin-bottom: 0;">
              <!-- Search -->
              <div class="reports-toolbar__search">
                <img src="../../../../../assets/images/New_Icons/search-icon.svg" alt="Search Icon" />
                <input type="text" (keyup)="onFiltersApplied()" [(ngModel)]="search" name="search" autocomplete="off" placeholder="Search by business and mobile number" />
                <button *ngIf="search !== ''" type="button" (click)="search = '';$event.stopPropagation();onFiltersApplied()" class="reports-toolbar__clear-btn" title="Clear search">&times;</button>
              </div>
              <div class="reports-toolbar__select-wrapper">
                

                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Select Status</mat-label>
                  <mat-select id="status" name="status" (selectionChange)="statusFilter = true; onFiltersApplied()"
                              [(ngModel)]="status">
                    <mat-option value="undefined" disabled>Select Status</mat-option>
                    <mat-option value="false">Active</mat-option>
                    <mat-option value="true">In Active</mat-option>
                  </mat-select>

                  <!-- Clear-filter button -->
                  <button mat-icon-button type="button" title="Clear Filters" class="reports-toolbar__clear-btn reports-toolbar__clear-btn--filter" (click)="statusFilter = false; status = undefined; $event.stopPropagation();onFiltersApplied()" *ngIf="statusFilter">
                    &times;
                  </button>
                </mat-form-field>
              </div>
            </div>
            <div class="row table-responsive list" style="padding: 12px 14px;">
              <table class="table business-contacts-table" *ngIf="isBusinessContactsTabActive">
                <thead>
                <tr>
                  <th style="width: 50px;">S.No</th>
                  <th>Business Name</th>
                  <th class="handSymbol" (click)="businessContactsColumnSorting('creditsIssued')" style="text-align: center;">Contacts Issued
                    <span class="glyphicon sort-icon" [ngClass]="{'glyphicon-chevron-up':sortCreditsIssued,'glyphicon-chevron-down':!sortCreditsIssued}"></span>
                  </th>
                  <th class="handSymbol" (click)="businessContactsColumnSorting('creditsUsed')" style="text-align: center;">Contacts Used
                    <span class="glyphicon sort-icon" [ngClass]="{'glyphicon-chevron-up':sortCreditsused,'glyphicon-chevron-down':!sortCreditsused}"></span>
                  </th>
                  <th class="handSymbol" (click)="businessContactsColumnSorting('durationLeft')">Days left
                    <span class="glyphicon sort-icon" [ngClass]="{'glyphicon-chevron-up':sortDurationleftDays,'glyphicon-chevron-down':!sortDurationleftDays}"></span>
                  </th>
                  <th style="width: 120px; text-align: center;">Status</th>
                </tr>
                </thead>
                <tbody class="table-list-container">
                <tr class="subscriber-row" *ngFor="let list of filteredBusinessContacts; let i = index">
                  <td style="vertical-align: top; padding-top: 14px;">{{i+1}} </td>
                  <td style="vertical-align: top; padding-top: 14px; cursor: pointer;" (click)="getSubscriberUsageTracker(list.id)">
                    <span>{{list.businessName || '--'}}</span>
                  </td>
                  <td style="padding-top: 14px; text-align: center; cursor: pointer;" (click)="getSubscriberUsageTracker(list.id)">
                    {{list.creditsIssued }}
                  </td>
                  <td style="padding-top: 14px; text-align: center; cursor: pointer;" (click)="getSubscriberUsageTracker(list.id)">
                    {{list.creditsUsed }}
                  </td>
                  <td style="padding-top: 14px; text-align: center; cursor: pointer;" (click)="getSubscriberUsageTracker(list.id)">
                    {{list.duration}}
                  </td>
                  <td style="vertical-align: top; padding-top: 14px;">
                    <div class="status-cell">
                      <span [ngClass]="!list.isExpired ? 'active-status' : 'inactive-status'">{{ list.isExpired ? 'Inactive' : 'Active' }}</span>
                      <i class="fa fa-edit edit-device-icon" *ngIf="list.isExpired == false && list.policyDetails?.name != 'Trial'" (click)="existingSubscriberPreview(list)" data-toggle="modal" data-target="#addModal" data-backdrop="static" data-keyboard="false" title="Edit Subscription"></i>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
              <table class="table blueye-subscribers-table" *ngIf="isBluEyeSubscribersTabActive">
                <thead>
                <tr>
                  <th style="width: 50px;">S.No</th>
                  <th>Business Name</th>
                  <th>Device No</th>
                  <th>Days Left</th>
                  <th>User Licenses (Count)</th>
                  <th>Status</th>
                  <th style="text-align: center;">Invoice</th>
                  <th style="text-align: center;">Assign</th>
                </tr>
                </thead>
                <tbody *ngFor="let list of filteredBluEyeSubscribers; let i = index" class="business-group">
                  <!-- When business has device(s) -->
                  <tr *ngFor="let device of list.devicesDetails; let devIdx = index" [ngClass]="{'border-top-group': devIdx === 0}">
                    <!-- S.No (spans all devices of this business) -->
                    <td *ngIf="devIdx === 0" [attr.rowspan]="list.devicesDetails?.length || 1" style="vertical-align: top; padding-top: 14px;">
                      {{i+1}}
                    </td>
                    <!-- Business Name (spans all devices of this business) -->
                    <td *ngIf="devIdx === 0" [attr.rowspan]="list.devicesDetails?.length || 1" style="vertical-align: top; padding-top: 14px; cursor: pointer;" (click)="getSubscriberUsageTracker(list.id)">
                      <span>{{ list.businessName || '--' }}</span>
                    </td>
                    <!-- Device Number -->
                    <td style="vertical-align: top; padding-top: 14px; cursor: pointer;" (click)="getSubscriberUsageTracker(list.id)">
                      <span>{{ device.deviceNumber || '--' }}</span>
                    </td>
                    <!-- Days Left -->
                    <td style="vertical-align: top; padding-top: 14px; cursor: pointer;" (click)="getSubscriberUsageTracker(list.id)">
                      <span>{{ device?.bluEye?.durationLeft || '--' }}</span>
                    </td>
                    <!-- Licenses Details -->
                    <td style="vertical-align: top; padding-top: 10px; cursor: pointer;" (click)="getSubscriberUsageTracker(list.id)">
                      <div class="license-item-row" *ngFor="let license of device?.bluEye?.userLicensesDetails">
                        <span class="lic-role">{{ license.roleName || '--' }}</span>
                        <span class="lic-count">{{ (license.noOfLicenses) || '0' }}</span>
                      </div>
                      <span *ngIf="!device?.bluEye?.userLicensesDetails || device?.bluEye?.userLicensesDetails.length === 0">--</span>
                    </td>
                    <!-- Status & Edit -->
                    <td style="vertical-align: top; padding-top: 14px;">
                      <div class="status-cell">
                        <span [ngClass]="device.isActive ? 'active-status' : 'inactive-status'">{{ device.isActive ? 'Active' : 'Inactive' }}</span>
                        <i class="fa fa-edit edit-device-icon" (click)="onEditSubscriber(list, device);" data-toggle="modal" data-target="#addModal" data-backdrop="static" data-keyboard="false" title="Edit Device"></i>
                      </div>
                    </td>
                    <!-- Invoice -->
                    <td style="vertical-align: top; padding-top: 14px; text-align: center;">
                      <span class="invoice-text" (click)="getInvoice(list)">Invoice</span>
                    </td>
                    <!-- Assign -->
                    <td style="vertical-align: top; padding-top: 14px; text-align: center;">
                      <span class="invoice-text" (click)="assignPu(list, device)">Assign</span>
                    </td>
                  </tr>

                  <!-- Fallback when business has 0 devices -->
                  <tr class="border-top-group" *ngIf="!list.devicesDetails || list.devicesDetails.length === 0">
                    <td style="vertical-align: top; padding-top: 14px;">{{i+1}}</td>
                    <td style="vertical-align: top; padding-top: 14px; cursor: pointer;" (click)="getSubscriberUsageTracker(list.id)">
                      <span>{{ list.businessName || '--' }}</span>
                    </td>
                    <td colspan="6" style="vertical-align: middle; text-align: center; color: #888;">
                      No devices subscribed
                    </td>
                  </tr>
                </tbody>
              </table>
              <div *ngIf="listLoader" class="loader-div">
                <div class="adjust">
                  <div class="loader2 list-loader"></div>
                </div>
              </div>
            </div>
            <div *ngIf="(isBusinessContactsTabActive && filteredBusinessContacts && filteredBusinessContacts.length == 0)
                || (isBluEyeSubscribersTabActive && filteredBluEyeSubscribers && filteredBluEyeSubscribers.length == 0)" class="noDataFoundMessage">
              {{search != '' && businessTypeFilter ? 'No items match your search and filter' : (search != '' ? 'No items match your search' : 'No items match your filter')}}
            </div>
          </div>
          <div *ngIf="isBusinessContactsTabActive && businessContacts && businessContacts.length == 0"
               class="noDataFoundMessage">
            Data not available
          </div>
        </div>
      </div>
      <div *ngIf="subscribersList && subscribersList.length == 0" class="noDataFoundMessage">
        Data Not Found
      </div>
    </div>
  </div>
  <div class="dynamic-form-wrapper" [ngClass]="{  'slide-in-overlay': formFieldCount > 7 }" *ngIf="showForm">
    <div class="popup-wrapper">
      <button type="button" class="popup-close-beside" (click)="onFormClose()" title="Close">&times;</button>
      <!-- Actual Popup -->
      <div [ngClass]="{'form-container-panel': formFieldCount > 7, 'popup-inner': formFieldCount <= 7 }" style="width: 500px;">
        <form [formGroup]="registerForm" novalidate>
          <!-- Title -->
          <div class="form-header">
            <div class="form-title">Subscription</div>
            <button class="add-update-submit-button" (click)="submitButton ? onFormSubmit() : updateExistingSubscriber()" [disabled]="
            !this.registerForm.valid || 
            !this.registerForm.get('termsAccepted').value || 
            enableDisableSubmitButton || 
            (finalmatchedDevice?.length && finalmatchedDevice[0]?.isActive === true) ||
            sameMatchingDevice?.length > 0
            ">
              <span class="icon"><img src="../../../../assets/images/New_Icons/tick-icon.svg"></span>
              <span class="text">{{ submitButton ? 'Submit' : 'Update'}}</span>
            </button>
          </div>
          <div class="form-container">
            <!-- Policy Type Selection Field -->
            <div class="radio-selection">
              <h3>Policy Type</h3>
              <mat-radio-group formControlName="creditPolicyType" (change)="getCreditPoliciesByPolicyType()" aria-label="Policy Type">
                <mat-radio-button *ngFor="let list of policyNamesList" [value]="list.policy_type_name" [id]="list.policy_type_name" [ngClass]="{ disbledCls: updateButton }" style="margin-bottom: 0 !important;">
                  {{ list.policy_type_name }}
                </mat-radio-button>
              </mat-radio-group>
            </div>
            <!-- Policy Selection Field -->
            <div class="form-field" *ngIf="policyTypeName">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Policy</mat-label>
                <mat-select name="creditPolicyName" formControlName="creditPolicyName" (selectionChange)="getCreditPolicy()" [ngClass]="{ disbledCls: updateButton }">
                  <mat-option value="" disabled>Select Policy</mat-option>
                  <mat-option *ngFor="let list of filteredCreditPoliciesList" [value]="list.id">
                    {{ list.policyName }}
                  </mat-option>
                </mat-select>
                <!-- Optional hint -->
                <mat-hint *ngIf="!policyId && f.creditPolicyName.valid">
                  <i>Select Policy</i>
                </mat-hint>
                <mat-hint *ngIf="policyId && f.creditPolicyName.valid">
                  <i>Policy selected</i>
                </mat-hint>
                <!-- Validation error -->
                <mat-error *ngIf="(f.creditPolicyName.touched || f.creditPolicyName.dirty || submitted) && f.creditPolicyName.invalid">
                  <i>Policy selection is required.</i>
                </mat-error>
              </mat-form-field>
              <!-- Policy Details Display -->
              <div class="policy-details" *ngIf="policyId" style="margin-bottom: 1rem;">
                <p>Policy duration: &nbsp;{{ creditPolicy?.validityPeriod.duration }}</p>
                <p *ngIf="creditPolicy?.policyName == 'BluEye Launch Plan'">
                  User Licenses: &nbsp;2
                </p>
                <p *ngIf="creditPolicy?.creditType != 'BluEye SC'">
                  Credits applied: &nbsp;{{ creditPolicy?.appliedCredits }}
                </p>
                <p>Policy cost: &nbsp;{{ creditPolicy?.policyCost }}</p>
              </div>
            </div>
            <!--Paid for selection field-->
            <div class="form-field">
              <h3>Paid For</h3>
              <div class="country-cum-mobilenumber-entry-field">
                <div class="country-dropdown">
                  <mat-form-field appearance="outline" class="w-100" [readonly]="updateButton">
                    <!-- “placeholder” shows until something is selected -->
                    <mat-label>Country</mat-label>
                    <mat-select name="paidForCountryName" formControlName="paidForCountryName" (selectionChange)="paidForcountrySelected()" [ngClass]="{'disbledCls': updateButton }">
                      <!-- Optional first disabled option (keeps your “undefined” sentinel) -->
                      <mat-option value="undefined" disabled>Country</mat-option>
                      <!-- Render your countries just like before -->
                      <mat-option *ngFor="let paidFor of countriesList" [value]="paidFor.dialCode">
                        {{ paidFor.isoCode }}&nbsp;({{ paidFor.dialCode }})
                      </mat-option>
                    </mat-select>
                    <!-- Validation / helper feedback (adapt as you like) -->
                    <mat-hint *ngIf="f?.paidForCountryName?.invalid && (submitted || f.paidForCountryName.touched)">
                      <span class="text-danger">required</span>
                    </mat-hint>
                    <mat-hint *ngIf="f?.paidForCountryName?.valid">
                      <span class="text-success">Country selected</span>
                    </mat-hint>
                  </mat-form-field>
                </div>
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Mobile <span class="text-danger">*</span></mat-label>
                  <input matInput type="text" name="paidForMobileNumber" formControlName="paidForMobileNumber" autocomplete="off" style="padding: 0;" (keyup)="getBusinessAndPersonDetails()" [readonly]="updateButton" />
                  <!-- helper hint -->
                  <mat-hint *ngIf="f.paidForMobileNumber.valid">
                    <i>Looks good</i>
                  </mat-hint>
                  <!-- validation -->
                  <mat-error *ngIf=" (f.paidForMobileNumber.touched || f.paidForMobileNumber.dirty || submitted) && f.paidForMobileNumber.invalid ">
                    <i> {{ f.paidForMobileNumber.hasError('required') ? 'Mobile number is required.' : f.paidForMobileNumber.hasError('pattern') ? 'Numbers only.' : ''}}</i>
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <!--Business Name and Person Name display field -->
            <div class="business-details" *ngIf="businessName">
              <p>Business name: &nbsp;{{ businessName }}</p>
              <p *ngIf="creditPolicy?.policyName != 'BluEye Launch Plan'">Person name: &nbsp;{{ personName }}</p>
              <p *ngIf="termsAccepted && creditPolicy?.policyName != 'BluEye Launch Plan'">Terms &nbsp;<span style="color: #44C466;">ACCEPTED</span></p>
              <p *ngIf="!termsAccepted && creditPolicy?.policyName != 'BluEye Launch Plan'">Terms &nbsp;<span style="color: red;">NOT ACCEPTED</span></p>
            </div>
            <!--Devices List field-->
            <div class="devices-list-container" *ngIf="businessName && (creditPolicy && creditPolicy.policyName == 'BluEye Launch Plan')" style="margin-top: 1rem;">
              <h4 style="text-align: left;">Subscribed Devices</h4>
              <p *ngIf="isSubscribedDevicesAvailable()">There are no devices subscribed click to add new devices</p>
              <!-- Add New Button with Device ID -->
              <div class="new-ul-container" *ngIf="submitButton">
                <button class="add-new-btn" (click)="addCardToExistingDevicesList()">➕ New Device</button>
              </div>
              <div *ngFor="let card of bluEyePolicyObject?.devicesDetails; let cardIdx = index" class="devices-card">
                <div class="devices-card-header" (click)="toggleCard(cardIdx)">
                  <h2># Device{{ cardIdx + 1 }} <span *ngIf="!card.isActive" class="expired-label">Expired</span></h2>
                  <span class="delete-cheveron-icons">
                        <!-- Show delete icon for newly added Cards -->
                        <span *ngIf="card?.bluEye?.isAdditionalDevice" class="delete-icon" (click)="removeCardFromDevicesList(cardIdx)" title="Delete Device">
                          <img src="assets/images/New_Icons/delete-icon.svg" style="width: 16px; height: 16px; cursor: pointer;" alt="Delete" />
                        </span>
                        <i class="fa" [ngClass]="{'fa-chevron-up': activeIndex === cardIdx, 'fa-chevron-down': activeIndex !== cardIdx}"></i>
                      </span>
                </div>
                <div class="devices-card-body" *ngIf="activeIndex === cardIdx">
                  <div *ngIf="card?.isActive && card?.durationLeft != '0 days'; else existingDeviceContent">
                    <div class="device-input-container">
                      <label for="deviceNumber">Enter Device Number:</label>
                      <input id="deviceNumber" type="text" [(ngModel)]="card.deviceNumber" (input)="syncDeviceNumbers(cardIdx); checkDeviceNumber(card.deviceNumber, cardIdx)" [ngModelOptions]="{standalone: true}" placeholder="" required />
                    </div>
                    <p style="color: red" *ngIf="deviceMessages[cardIdx]">
                      {{ deviceMessages[cardIdx] }}
                    </p>
                    <!-- Show error message if input is invalid -->
                    <p class="error-message" *ngIf="validationErrors[cardIdx]">{{ validationErrors[cardIdx] }}</p>
                    <!-- Show content only if device number is valid -->
                    <div *ngIf="!validationErrors[cardIdx] && card.deviceNumber" style="margin-top: 1rem;">
                      <p>Device Hardware Cost: {{ card.bluePod.cost }}</p>
                      <p>Device Software Cost: {{ card.bluEye.cost }}</p>
                      <p>User Licenses (Owner 1, RT 2)</p>
                      <p>Validity 45 days</p>
                      <p>Total Cost: {{ card.bluePod.cost + card.bluEye.cost + creditPolicy?.devices?.[0].gstCostOnTotal }}</p>
                      <p>After entering the device number, save the details to proceed.</p>
                      <div class="user-licenses-container">
                        <!--Existing User licenses cards list -->
                        <div *ngFor="let license of card?.bluEye?.userLicensesDetails; let licIdx = index">
                          <div class="user-license-card">
                            <div class="license-info">
                              <span class="role-name">{{ license?.roleName }}</span>
                              <!-- Show delete icon for extra/non-default added licenses -->
                              <span *ngIf="!license?.isDefault || (license?.roleName !== 'Farmer' && license?.roleName !== 'Farm Manager')" class="delete-icon" title="Delete Role" (click)="removeUserLicense(card._id, licIdx, cardIdx)">
                                <img src="assets/images/New_Icons/delete-icon.svg" style="width: 16px; height: 16px; cursor: pointer;" alt="Delete" />
                              </span>
                            </div>
                            <div class="license-controls">
                              <!-- Disable minus button when count is 1 -->
                              <button class="license-btn license-minus-btn" (click)="updateUserLicense(card._id, license.roleID, -1, cardIdx)" [disabled]="license?.noOfLicenses === 1">-</button>
                              <span class="license-count">{{ license.noOfLicenses }}</span>
                              <!-- Disable plus button when count is 9 -->
                              <button class="license-btn license-plus-btn" (click)="updateUserLicense(card._id, license.roleID, 1, cardIdx)" [disabled]="license?.noOfLicenses === 9">+</button>
                            </div>
                          </div>
                        </div>
                        <!-- Add New Button with Device ID - visible only if less than 3 roles exist -->
                        <div class="new-ul-container" *ngIf="card?.bluEye?.userLicensesDetails?.length < 3">
                          <button class="add-new-btn" (click)="addNewUserLicense(card._id, cardIdx)">Add Extra UL</button>
                        </div>
                      </div>
                      <!-- Save & Cancel Buttons Row -->
                      <!-- Save & Cancel Buttons Row -->
                      <div class="buttons-row">
                        <button class="save-btn" (click)="saveUserLicenses(cardIdx)" [disabled]="deviceSaveState[cardIdx]?.isSaved">
                          Save
                        </button>
                        <button class="cancel-btn" (click)="removeCardFromDevicesList(cardIdx)">
                          Cancel
                        </button>
                      </div>
                      <!-- Message Box Appears After Save or Cancel -->
                      <div *ngIf="deviceSaveState[cardIdx]?.message" [ngClass]="{'success-message': deviceSaveState[cardIdx]?.isSaved, 'success-message': !deviceSaveState[cardIdx]?.isSaved}">
                        {{ deviceSaveState[cardIdx]?.message }}
                      </div>
                    </div>
                  </div>
                  <ng-template #existingDeviceContent>
                    <p>ID: {{ card.bluePod.id }}</p>
                    <p>Cost: {{ card.bluePod.cost + card.bluEye.cost }}</p>
                    <p>Validity: {{ card.bluEye.validity }}</p>
                    <p>Duration Left: {{ card.bluEye.durationLeft }}</p>
                    <div class="user-licenses-container">
                      <!-- Heading before the user license cards list -->
                      <h3 class="user-license-heading" *ngIf="card?.bluEye?.userLicensesDetails?.length > 0">
                        User Licenses
                      </h3>
                      <!--Existing User licenses cards list -->
                      <div class="user-license-card" *ngFor="let license of card?.bluEye?.userLicensesDetails; let licIdx = index">
                        <div class="license-info">
                          <span class="role-name">{{ license?.roleName }}</span>
                          <!-- Show delete icon for extra/non-default added licenses -->
                          <span *ngIf="!license?.isDefault || (license?.roleName !== 'Farmer' && license?.roleName !== 'Farm Manager')" class="delete-icon" title="Delete Role" (click)="removeUserLicense(card._id, licIdx, cardIdx)">
                            <img src="assets/images/New_Icons/delete-icon.svg" style="width: 16px; height: 16px; cursor: pointer;" alt="Delete" />
                          </span>
                        </div>
                        <div class="license-controls">
                          <!-- Disable minus button when count is 1 -->
                          <button class="license-btn license-minus-btn" (click)="updateUserLicense(card._id, license.roleID, -1, cardIdx)" [disabled]="license?.noOfLicenses === 1" *ngIf="card?.bluEye?.startDate != null && card?.isActive == true">-</button>
                          <span class="license-count">{{ license.noOfLicenses }}</span>
                          <!-- Disable plus button when count is 9 -->
                          <button class="license-btn license-plus-btn" (click)="updateUserLicense(card._id, license.roleID, 1, cardIdx)" [disabled]="license?.noOfLicenses === 9" *ngIf="card?.bluEye?.startDate != null && card?.isActive == true">+</button>
                        </div>
                      </div>
                      <!-- Add New Button with Device ID -->
                      <div class="new-ul-container" *ngIf="card.bluEye?.userLicensesDetails?.length < 3 && card?.bluEye?.startDate != null && card?.isActive == true">
                        <button class="add-new-btn" (click)="addNewUserLicense(card._id, cardIdx)">Add Extra UL</button>
                      </div>
                      <!--Renewal dropdown field-->
                      <div class="renewal-container" *ngIf="card?.isActive == false">
                        <!-- Row with Renew Checkbox -->
                        <div class="renew-checkbox-row">
                          <label class="checkbox-label">
                            <input type="checkbox" [checked]="card.renewalState?.isChecked || false" (change)="toggleRenewal($event, card._id, cardIdx); checkDeviceNumber(card.deviceNumber, cardIdx)"> Renew
                          </label>
                        </div>
                        <!-- Dropdown (Visible Only If Checkbox is Checked) -->
                        <div class="renewal-dropdown" *ngIf="card.renewalState?.isChecked">
                          <label for="renewal">Select Company Size:</label>
                          <select id="renewal" (change)="onRenewalChange($event, card._id, cardIdx)">
                            <option value="" disabled selected>Select an option</option>
                            <option *ngFor="let renewal of creditPolicy?.devices?.[0].renewals" [value]="renewal._id" [selected]="card.renewalState?.selectedRenewal?._id === renewal._id">
                              {{ renewal.companySize }} - ₹{{ renewal.blueEyeCost }}
                            </option>
                          </select>
                        </div>
                        <!-- Show selected cost -->
                        <div *ngIf="card.renewalState?.isChecked && card.renewalState?.selectedRenewal">
                          <p><strong>Renewal Cost:</strong> ₹{{ card.renewalState?.selectedRenewal?.blueEyeCost }}</p>
                        </div>
                      </div>
                      <!-- Total Cost Row -->
                      <div class="total-cost-row">
                        <strong>Total Cost (Includes GST):</strong> {{ card.totalCost || '0'}}
                      </div>
                      <!-- Save & Cancel Buttons Row -->
                      <div class="buttons-row">
                        <button class="save-btn" (click)="saveUserLicenses(cardIdx)" [disabled]="deviceSaveState[cardIdx]?.isSaved">
                          Save
                        </button>
                        <button class="cancel-btn" (click)="cancelDeviceChanges(cardIdx)">
                          Cancel
                        </button>
                      </div>
                      <!-- Message Box Appears After Save or Cancel -->
                      <div *ngIf="deviceSaveState[cardIdx]?.message" [ngClass]="{'success-message': deviceSaveState[cardIdx]?.isSaved, 'success-message': !deviceSaveState[cardIdx]?.isSaved}">
                        {{ deviceSaveState[cardIdx]?.message }}
                      </div>
                    </div>
                  </ng-template>
                </div>
              </div>
            </div>
            <!--Paid by selection field-->
            <div class="form-field" style="margin-top: 1rem;">
              <h3>Paid By</h3>
              <div class="country-cum-mobilenumber-entry-field">
                <div class="country-dropdown">
                  <mat-form-field appearance="outline" class="w-100" [ngClass]="{ disbledCls: updateButton }">
                    <!-- “placeholder” shows until something is selected -->
                    <mat-label>Country</mat-label>
                    <mat-select name="paidByCountryName" formControlName="paidByCountryName" (selectionChange)="paidBycountrySelected()">
                      <!-- Optional first disabled option (keeps your “undefined” sentinel) -->
                      <mat-option value="undefined" disabled>Country</mat-option>
                      <!-- Render your countries just like before -->
                      <mat-option *ngFor="let paidBy of countriesList" [value]="paidBy.dialCode">
                        {{ paidBy.isoCode }}&nbsp;({{ paidBy.dialCode }})
                      </mat-option>
                    </mat-select>
                    <!-- Validation / helper feedback (adapt as you like) -->
                    <mat-hint *ngIf="f?.paidByCountryName?.invalid && (submitted || f.paidByCountryName.touched)">
                      <span class="text-danger">required</span>
                    </mat-hint>
                    <mat-hint *ngIf="f?.paidByCountryName?.valid">
                      <span class="text-success">Country selected</span>
                    </mat-hint>
                  </mat-form-field>
                </div>
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Mobile</mat-label>
                  <!-- matInput preserves your name / formControlName -->
                  <input matInput type="text" name="paidByMobileNumber" formControlName="paidByMobileNumber" autocomplete="off" style="padding: 0;" />
                </mat-form-field>
              </div>
            </div>
            <!--Policy validity Date range-->
            <div *ngIf="(creditPolicy && creditPolicy?.policyName === 'BluEye Launch Plan')">
              <mat-form-field appearance="outline" class="w-100" [formGroup]="registerForm.get('dateRange')">
                <mat-label>Policy Validity <span class="text-danger">*</span></mat-label>
                <mat-date-range-input [rangePicker]="picker" [min]="minDate">
                  <input matStartDate placeholder="Start date" formControlName="start" readonly />
                  <input matEndDate placeholder="End date" formControlName="end" readonly />
                </mat-date-range-input>
                <!-- calendar button -->
                <button mat-icon-button matSuffix (click)="picker.open()" aria-label="Toggle date" class="calendar-toggle">
                  <mat-icon>calendar_today</mat-icon>
                </button>
                <mat-date-range-picker #picker (closed)="onPickerClosed()"></mat-date-range-picker>
                <!-- validation: show if group is touched/dirty + invalid -->
                <mat-error *ngIf=" (registerForm.get('dateRange').touched || registerForm.get('dateRange').dirty || submitted) && registerForm.get('dateRange').invalid ">
                  <i>Please select both start and end dates.</i>
                </mat-error>
                <mat-hint *ngIf="startDate && endDate">
                  <i>Date range selected</i>
                </mat-hint>
              </mat-form-field>
            </div>
            <!-- Show only when a policy is chosen -->
            <mat-form-field *ngIf="policyId" appearance="outline" class="w-100 paid-amount-field">
              <mat-label>Paid amount</mat-label>
              <!-- currency code shown before the input -->
              <!-- <span matPrefix class="currency-prefix">{{ countryCurrency }}&nbsp;</span> -->
              <!-- numeric input -->
              <input matInput type="text" id="paidamount" formControlName="paidAmount" autocomplete="off" placeholder="Enter paid amount" (blur)="onAmountBlur()" required />
              <!-- helper / validation -->
              <mat-hint *ngIf="f.paidAmount.invalid"><i>Numbers only</i></mat-hint>
              <mat-error *ngIf=" (f.paidAmount.touched || f.paidAmount.dirty || submitted) && f.paidAmount.errors ">
                <i>{{ f.paidAmount.hasError('required') ? 'This field is required.' : f.paidAmount.hasError('pattern') ? 'Only numbers are allowed.' : ''}}</i>
              </mat-error>
            </mat-form-field>
            <!--Payment mode selection field-->
            <div class="radio-selection">
              <h3>Payment Mode</h3>
              <div class="actions-block">
                <button *ngFor="let button of paymentOptions" [ngClass]="{ selected: button.isPaymentSelected }" (click)="togglePaymentOption(button)">
                  {{ button.paymentName }}
                </button>
              </div>
            </div>
            <!-- ───────── Reference-ID ───────── -->
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Transaction reference ID</mat-label>
              <input matInput id="referenceId" type="text" autocomplete="off" formControlName="referenceid" placeholder="Enter reference ID" (change)="onReferenceChanged()" />
              <!-- Helper / hint -->
              <mat-hint *ngIf="f.referenceid.valid"><i>Accepted: A-Z 0-9 / - (max 50)</i></mat-hint>
              <!-- Validation -->
              <mat-error *ngIf="(f.referenceid.dirty || f.referenceid.touched) && f.referenceid.errors">
                <i>{{f.referenceid.hasError('required')  ? 'This field is required.' :f.referenceid.hasError('pattern')   ? 'Only alphanumerics, hyphens and slash are allowed.' :''}}</i>
              </mat-error>
            </mat-form-field>
            <div>
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Paid Date</mat-label>
                <input matInput [value]="amountPaidDate" readonly placeholder="Paid Date" />
                <mat-icon matSuffix>event</mat-icon>
                <!-- optional calendar icon -->
              </mat-form-field>
            </div>
            <!-- ───────── Accept Terms ───────── -->
            <mat-checkbox [(ngModel)]="isPolicyAccepted" [ngModelOptions]="{ standalone: true }" (change)="updateTermsOfBusiness($event)" required>
              Accept terms&nbsp;&amp;&nbsp;privacy policy
            </mat-checkbox>
            <!--file upload-->
            <!--File Selection Field-->
            <div class="file-upload" *ngIf="creditPolicy?.policyName == 'BluEye Launch Plan'">
              <div class="file-description">
                <div>
                  <span class="drag-drop-file">Accepted file types</span>
                  <br>
                  <span class="file-format-info">(PDF)</span>
                </div>
              </div>
              <div class="input-file-upload">
                <div class="file_input_wrap" style="float: left;">
                  <input type="file" id="imageUpload" class="hide" (change)="fileupload($event)" autocomplete="off" accept="application/pdf" />
                  <label for="imageUpload" class="file">
                    <img src="../../../../assets/images/New_Icons/upload-square-svgrepo-com.svg" width="15px" height="15px">Upload PDF
                  </label>
                </div>
              </div>
            </div>
            <!--Selected File Image Display Field-->
            <div class="pdf-preview-container" *ngIf="selectedbase64file">
              <span class="close-icon" (click)="remove()">×</span>
              <iframe [src]="selectedbase64file" width="300" height="400" type="application/pdf"></iframe>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!--invoice popup-->
  <div class="modal" tabindex="-1" role="dialog" [ngClass]="{'show d-block': showInvoiceModal}" *ngIf="showInvoiceModal">
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content" style="max-height: 90vh; overflow: hidden;">
        <!-- Limit modal max height -->
        <div class="modal-header">
          <h5 class="modal-title">Invoice</h5>
          <button type="button" class="close" (click)="closeModal()" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <!-- This container will scroll if too many PDFs -->
        <div class="invoice-popup-container p-3" style="overflow-y: auto; max-height: 500px;">
          <div class="invoice-grid">
            <div class="invoice-item" *ngFor="let file of invoiceFiles; let i = index">
              <h6>Invoice {{ i + 1 }}</h6>
              <iframe [src]="file" width="100%" height="400px" frameborder="0"></iframe>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
  <!-- Overlay background -->
  <div class="modal-backdrop fade show" *ngIf="showInvoiceModal"></div>
  <!--assign device to site-->
  <div class="dynamic-form-wrapper" [ngClass]="{'floating-panel': 1 <= 7, 'slide-in-overlay': 1 > 7 }" *ngIf="showAssignDeassignForm">
    <div class="popup-wrapper">
      <button type="button" class="popup-close-beside" (click)="closeModal(); closeFarmsiteDetails()" title="Close">&times;</button>
      <!-- Actual Popup -->
      <div [ngClass]="{'form-container-panel': 1 > 7, 'popup-inner': 1 <= 7}">
        <div>
          <!-- Title -->
          <div class="form-header">
            <div class="form-title">Device Details</div>
            <button class="add-update-submit-button" (click)="deviceDetails.farmSiteId ? deAssign() : assignDevice()" [disabled]="!this.farmSiteId">
              <span class="icon"><img src="../../../../assets/images/New_Icons/tick-icon.svg"></span>
              <span class="text">{{ deviceDetails.farmSiteId ? 'Remove' : 'Assign' }}</span>
            </button>
          </div>
          <div class="form-container">
            <div class="device-card">
              <div class="device-header">
                <div class="device-id">{{ deviceDetails && deviceDetails.bluePod && deviceDetails.bluePod.id}}</div>
                <div class="status-badge" [ngClass]="deviceDetails?.isActive ? 'active' : 'inactive'">
                  {{ deviceDetails?.isActive ? 'Active' : 'Inactive' }}
                </div>
              </div>
              <div class="subscribed-date">Subscribed on {{deviceDetails && deviceDetails.bluEye && deviceDetails.bluEye.startDate | date: 'dd MMM yyyy'}}</div>
              <!--farmsite-->
              <div class="form-field" *ngIf="policyDetails && policyDetails.businessType == 'Farm'">
                <!-- Mat wrapper -->
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Farm site</mat-label>
                  <!-- Mat select keeps the same id & two-way binding -->
                  <mat-select id="farmsiteid" [(ngModel)]="farmSiteId">
                    <!-- Disabled default option -->
                    <mat-option value="undefined" disabled>
                      Select Farm Site
                    </mat-option>
                    <!-- Dynamic options -->
                    <mat-option *ngFor="let site of farmSites" [value]="site.id">
                      {{ site.farmNameAtLocation }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div *ngIf="farmSites && farmSites.length == 0 && (policyDetails && policyDetails.businessType == 'Farm')">
                <p class="info-message"><span><img src="assets/images/New_Icons/info-icon.svg" width="20" height="20"></span> Farm site are not available for this business.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--credi usage traker etails-->
  <div class="modal" tabindex="-1" role="dialog" [ngClass]="{'show d-block': isPopupOpen}" *ngIf="isPopupOpen">
    <div class="modal-dialog modal-lg usage-tracker-body" role="document">
      <div class="modal-content" style="max-height: 100vh; overflow: hidden;">
        <!-- Limit modal max height -->
        <div class="modal-header modal-header-custom row">
          <div class="modal-title col-xs-6"></div>
          <div class="col-xs-6">
            <button type="button" class="close close-btn close-device-details" (click)="closePopup();" aria-label="Close">×</button>
          </div>
        </div>
        <div class="modal-body">
          <div class="data-container">
            <div class="adjust" *ngIf="popupLoader">
              <div class="loader2"></div>
            </div>
            <div class="farm-popup" *ngIf="!popupLoader && subscriberUsageTrackerView && subscriberUsageTrackerView.length > 0">
              <div class="reports-toolbar" style="width: 60%;margin-bottom: 0;padding: 0;" *ngIf="(businessContactsTrackerView && businessContactsTrackerView.length > 5)">
                <!-- Search -->
                <div class="reports-toolbar__search">
                  <img src="../../../../../assets/images/New_Icons/search-icon.svg" alt="Search Icon" />
                  <input type="text" (keyup)="onUsageTrackerSearch()" [(ngModel)]="usageTrackersearch" name="searchField" autocomplete="off" placeholder="Search by business, person and mobile number" />
                  <button *ngIf="usageTrackersearch !== ''" type="button" (click)="filteredSubscriberUsageTrackerViews = businessContactsTrackerView;usageTrackersearch='';$event.stopPropagation()"
                          class="reports-toolbar__clear-btn" title="Clear search">&times;</button>
                </div>
              </div>
              <div class="row" style="margin-bottom: 15px;margin-left: 0;margin-right: 0;">
                <div class="col-xs-12">
                  <div class="row">
                    <ul class="nav nav-tabs batch batchtransactiontabs navViewTab">
                      <li (click)="switchTrackerViewTabs('businessContacts')" [ngClass]="{ 'active' : businessContactViewTabActive}" *ngIf="businessContactsTrackerView && businessContactsTrackerView.length > 0 && (isBusinessContactsTabActive)"><a data-toggle="tab" href="#businessContacts">Business Contacts</a></li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="table-container" *ngIf="businessContactsTrackerView && businessContactsTrackerView.length > 0 && businessContactViewTabActive">
                <table class="table">
                  <thead>
                  <tr>
                    <th>Business Name</th>
                    <th>Person Name</th>
                    <th>Mobile Number</th>
                  </tr>
                  </thead>
                </table>
                <div class="table-body-container" (scroll)="onTrackerScroll($event)">
                  <table class="table">
                    <tbody>
                    <tr class="table-color" *ngFor="let list of filteredSubscriberUsageTrackerViews">
                      <td>{{list.businessName || 'NA'}}</td>
                      <td>{{list.personName || 'NA'}}</td>
                      <td>{{list.mobileNumber.dialingCode }} &nbsp;{{list.mobileNumber.phoneNumber }}</td>
                    </tr>
                    </tbody>
                  </table>
                  <div class="adjust" *ngIf="trackerListLoader" style="height: 50px;">
                    <div class="loader2"></div>
                  </div>
                </div>
                <div class="farm-popup noDataFoundMessage" *ngIf="filteredSubscriberUsageTrackerViews && filteredSubscriberUsageTrackerViews.length == 0">
                  No items match your search
                </div>
              </div>
            
              <div class="table-container" *ngIf="BlueEyeSubscribersTrackerView?.length > 0 && bluEyePolicyViewTabActive">
                <table class="table fixed-header-table">
                  <thead>
                  <tr>
                    <th>Date</th>
                    <th>Business</th>
                    <th>Person Name</th>
                    <th>{{ displayLocationHeader }}</th>
                    <th>Device ID</th>
                    <th>PL Stage</th>
                    <th>Estimated seed count</th>
                    <th>Comments</th>
                  </tr>
                  </thead>
                </table>
                <div class="table-body-scroll" (scroll)="onTrackerScroll($event)">
                  <table class="table fixed-header-table">
                    <tbody>
                    <tr class="table-color" *ngFor="let list of filteredBlueEyeSubscribersTrackerView">
                      <td>{{(list.createdAt | date: 'dd MMM yyyy, h:mm:ss a':'IST') || 'NA'}}</td>
                      <td>{{ list.businessName }}</td>
                      <td>{{ list.personName }}</td>
                      <td>{{ list.bluEyeTrack.prodUnitLocation ? list.bluEyeTrack.prodUnitLocation : list.bluEyeTrack.farmSiteName}}</td>
                      <td>{{ list.bluEyeTrack?.bluPodId }}</td>
                      <td>{{ list.bluEyeTrack?.plStage }}</td>
                      <td>{{ list.bluEyeTrack?.bluEyeEstSeedCount }}</td>
                      <td>{{ list.bluEyeTrack?.comment }}</td>
                    </tr>
                    </tbody>
                  </table>
                  <div class="adjust" *ngIf="trackerListLoader" style="height: 50px;">
                    <div class="loader2"></div>
                  </div>
                </div>
                <div class="farm-popup noDataFoundMessage" *ngIf="filteredBlueEyeSubscribersTrackerView?.length === 0">
                  No items match your search
                </div>
              </div>

            </div>
            <div class="farm-popup noDataFoundMessage" *ngIf="!popupLoader && subscriberUsageTrackerView && subscriberUsageTrackerView.length == 0">
              Credits usage tracker details not found
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>